

                    if (document.querySelector('.beae-zv4jk8xr:not([data-beae-bind])')) {
                        (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                            $el: document.querySelector('.beae-zv4jk8xr:not([data-beae-bind])'),
                            
                            id: 'beae-zv4jk8xr',
                            isLive: true
                        });
                        document.querySelector('.beae-zv4jk8xr:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                
                    if (document.querySelector('.beae-ke7zxsj6:not([data-beae-bind])')) {
                        (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                            $el: document.querySelector('.beae-ke7zxsj6:not([data-beae-bind])'),
                            
                            id: 'beae-ke7zxsj6',
                            isLive: true
                        });
                        document.querySelector('.beae-ke7zxsj6:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                
                    if (document.querySelector('.beae-omf38p0z:not([data-beae-bind])')) {
                        (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                            $el: document.querySelector('.beae-omf38p0z:not([data-beae-bind])'),
                            
                            id: 'beae-omf38p0z',
                            isLive: true
                        });
                        document.querySelector('.beae-omf38p0z:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                